import * as $runtime from "../runtime.js";
import * as Data$dDateTime from "../Data.DateTime/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
const $AssignmentMode = tag => ({tag});
const $OrderType = tag => ({tag});
const $RequestedTime = (tag, _1) => ({tag, _1});
const Asap = /* #__PURE__ */ $RequestedTime("Asap");
const RequestedTime = value0 => $RequestedTime("RequestedTime", value0);
const PreOrder = /* #__PURE__ */ $OrderType("PreOrder");
const TakeAway = /* #__PURE__ */ $OrderType("TakeAway");
const Delivery = /* #__PURE__ */ $OrderType("Delivery");
const DeliveryZone = x => x;
const AutoAssign = /* #__PURE__ */ $AssignmentMode("AutoAssign");
const ManualAssign = /* #__PURE__ */ $AssignmentMode("ManualAssign");
const newtypeDeliveryZone = {Coercible0: () => {}};
const genericRequestedTime = {
  to: x => {
    if (x.tag === "Inl") { return Asap; }
    if (x.tag === "Inr") { return $RequestedTime("RequestedTime", x._1); }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Asap") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "RequestedTime") { return Data$dGeneric$dRep.$Sum("Inr", x._1); }
    $runtime.fail();
  }
};
const showRequestedTime = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Asap"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Data$dDateTime.showDateTime.show(v)]})({reflectSymbol: () => "RequestedTime"});
    return x => {
      if (x.tag === "Asap") { return $0["genericShow'"](Data$dGeneric$dRep.NoArguments); }
      if (x.tag === "RequestedTime") { return $1["genericShow'"](x._1); }
      $runtime.fail();
    };
  })()
};
const genericOrderType = {
  to: x => {
    if (x.tag === "Inl") { return PreOrder; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return TakeAway; }
      if (x._1.tag === "Inr") { return Delivery; }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "PreOrder") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "TakeAway") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "Delivery") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments)); }
    $runtime.fail();
  }
};
const showOrderType = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "PreOrder"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "TakeAway"});
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Delivery"});
    return x => {
      const $3 = genericOrderType.from(x);
      if ($3.tag === "Inl") { return $0["genericShow'"]($3._1); }
      if ($3.tag === "Inr") {
        if ($3._1.tag === "Inl") { return $1["genericShow'"]($3._1._1); }
        if ($3._1.tag === "Inr") { return $2["genericShow'"]($3._1._1); }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const genericDeliveryZone = {to: x => x, from: x => x};
const showDeliveryZone = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Data$dShow.showIntImpl(v)]})({reflectSymbol: () => "DeliveryZone"});
    return x => $0["genericShow'"](x);
  })()
};
const genericAssignmentMode = {
  to: x => {
    if (x.tag === "Inl") { return AutoAssign; }
    if (x.tag === "Inr") { return ManualAssign; }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "AutoAssign") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "ManualAssign") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments); }
    $runtime.fail();
  }
};
const showAssignmentMode = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "AutoAssign"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "ManualAssign"});
    return x => {
      if (x.tag === "AutoAssign") { return $0["genericShow'"](Data$dGeneric$dRep.NoArguments); }
      if (x.tag === "ManualAssign") { return $1["genericShow'"](Data$dGeneric$dRep.NoArguments); }
      $runtime.fail();
    };
  })()
};
const eqRequestedTime = {
  eq: x => y => {
    if (x.tag === "Asap") {
      if (y.tag === "Asap") { return true; }
      if (y.tag === "RequestedTime") { return false; }
      $runtime.fail();
    }
    if (x.tag === "RequestedTime") {
      if (y.tag === "Asap") { return false; }
      if (y.tag === "RequestedTime") { return Data$dDateTime.eqDateTime.eq(x._1)(y._1); }
      $runtime.fail();
    }
    if (y.tag === "Asap") { $runtime.fail(); }
    if (y.tag === "RequestedTime") { $runtime.fail(); }
    $runtime.fail();
  }
};
const eqOrderType = {
  eq: x => y => {
    const $0 = genericOrderType.from(x);
    const $1 = genericOrderType.from(y);
    if ($0.tag === "Inl") { return $1.tag === "Inl"; }
    if ($0.tag === "Inr") {
      if ($1.tag === "Inr") {
        if ($0._1.tag === "Inl") { return $1._1.tag === "Inl"; }
        if ($0._1.tag === "Inr") { return $1._1.tag === "Inr"; }
        return false;
      }
      return false;
    }
    return false;
  }
};
const eqDeliveryZone = {eq: x => y => x === y};
const eqAssignmentMode = {
  eq: x => y => {
    if (x.tag === "AutoAssign") {
      if (y.tag === "AutoAssign") { return true; }
      if (y.tag === "ManualAssign") { return false; }
      $runtime.fail();
    }
    if (x.tag === "ManualAssign") {
      if (y.tag === "AutoAssign") { return false; }
      if (y.tag === "ManualAssign") { return true; }
      $runtime.fail();
    }
    if (y.tag === "AutoAssign") { $runtime.fail(); }
    if (y.tag === "ManualAssign") { $runtime.fail(); }
    $runtime.fail();
  }
};
const defaultDeliveryZone = 1;
const defaultAssignmentMode = AutoAssign;
export {
  $AssignmentMode,
  $OrderType,
  $RequestedTime,
  Asap,
  AutoAssign,
  Delivery,
  DeliveryZone,
  ManualAssign,
  PreOrder,
  RequestedTime,
  TakeAway,
  defaultAssignmentMode,
  defaultDeliveryZone,
  eqAssignmentMode,
  eqDeliveryZone,
  eqOrderType,
  eqRequestedTime,
  genericAssignmentMode,
  genericDeliveryZone,
  genericOrderType,
  genericRequestedTime,
  newtypeDeliveryZone,
  showAssignmentMode,
  showDeliveryZone,
  showOrderType,
  showRequestedTime
};
